import { tokenStorage } from "./apiClient";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

/**
 * Open a Spaces file via authenticated admin proxy (works even if object ACL is private).
 * Also attempts the public URL first in a new tab after proxy succeeds as fallback display.
 */
export async function openStorageUrl(url) {
  if (!url) return;
  const token = tokenStorage.getAccessToken();
  const proxy = `${API_BASE_URL}/api/v1/admin/storage/proxy?url=${encodeURIComponent(url)}`;
  try {
    const response = await fetch(proxy, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
    if (!response.ok) {
      // Last resort: try public URL (may 403 if still private).
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }
    const blob = await response.blob();
    const objectUrl = URL.createObjectURL(blob);
    window.open(objectUrl, "_blank", "noopener,noreferrer");
    setTimeout(() => URL.revokeObjectURL(objectUrl), 60_000);
  } catch {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
